"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_CLASSES = exports.UNDERLINE_CLASSES = void 0;
var UNDERLINE_CLASSES = {
  false: 'uiLinkWithoutUnderline',
  true: 'uiLinkWithUnderline private-link--underlined'
};
exports.UNDERLINE_CLASSES = UNDERLINE_CLASSES;
var USE_CLASSES = {
  blue: '',
  dark: 'uiLinkDark',
  danger: 'private-link--danger',
  light: 'uiLinkLight',
  'on-dark': 'uiLinkLight private-link--on-dark',
  'on-bright': 'private-link--on-bright',
  mention: 'private-link--mention',
  unstyled: 'private-link--unstyled'
};
exports.USE_CLASSES = USE_CLASSES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/link/LinkConstants.js
// module id = 400
// module chunks = 5 6 7